<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">Select a bank account</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content>

    <section class="existing_account_sec">
        <div class="row">
        <div class="col-sm-6" *ngFor="let item of parentdata?.bankAccounts">
            <mat-card appearance="outlined" (click)="selectAccount(item)" >
                <div class="check_card_icon" [ngClass]="{'greend': item.isSelected == 1}">
                    <mat-icon>check</mat-icon>
                </div>
            <div class="existing_card_new">
                  
                    <div class="bank_img_sc">
                       <img src="../../../../assets/images/razorpay_logo.png" alt=""/>
                    </div>
                    <div class="bake_name_list">
                        <p>Razorpay account id: {{item.razorpay_account_id}}</p>
                        <p>Added on: {{item.creation_time | date}}</p>
                    </div>
            
            </div>
        </mat-card>
        </div>
       
        </div>
    </section>

 
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
    (click)="onPost()"
      [disabled]="!selectedAccount"
      mat-flat-button
      color="accent">
      Confirm 
    </button>
  </mat-dialog-actions>